module.exports = __webpack_public_path__ + "media/images/icon_article01_on_19-19-c2ea7c4872940e262c950ee6930e4fb4.png";